import styled from 'styled-components';
import {dFlexColumnCenter} from '../../globalVariables/GlobalFlex';
import {getFontSize, getFontWeight, getSpacing} from '@tickchak/react-share/app';

export const container = styled.div`
    ${dFlexColumnCenter}
    width: 100%;
    height: calc(100% - 100px);
    gap: ${getSpacing('spaceXl')};
`;

export const image = styled.img`
    width: 300px;
`;

export const title = styled.div`
    text-align: center;
    font-size: ${getFontSize('h3')};
    font-weight: ${getFontWeight('bold')};
`;
export const description = styled.div`
    text-align: center;
    font-size: ${getFontSize('body')};
    max-width: 540px;
`;

